import { render, staticRenderFns } from "./Otherdetails.vue?vue&type=template&id=2ff571ee&scoped=true"
import script from "./Otherdetails.vue?vue&type=script&lang=js"
export * from "./Otherdetails.vue?vue&type=script&lang=js"
import style0 from "./Otherdetails.vue?vue&type=style&index=0&id=2ff571ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff571ee",
  null
  
)

export default component.exports